import React from "react";
import AdminOnboarding from "./AdminOnboarding/AdminOnboarding";
import AppAd from "./AppAd";
var PerkboxWidgets = function (_a) {
    var canEdit = _a.canEdit, hasPerks = _a.hasPerks, tenant = _a.tenant;
    return (React.createElement(React.Fragment, null,
        canEdit && hasPerks && React.createElement(AdminOnboarding, { tenantId: tenant.uuid }),
        React.createElement(AppAd, null)));
};
export default PerkboxWidgets;
